

export default function NotAllowedPage() {
  return (
    <div id="error-page">
      <h1>Sorry! You don&apos;t have access to this page.</h1>
    </div>
  );
}
